/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:49
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodView',["$log","WorkingPeriodDayView","DateSrv","WorkingPeriodDay","Period","SiteData","WorkingPeriod", "$locale", "gettextCatalog","moment",
        function ($log,WorkingPeriodDayView,DateSrv,WorkingPeriodDay,Period,SiteData,WorkingPeriod, $locale, gettextCatalog, moment){

        var  WorkingPeriodView = function(workingPeriod,modelIndex)
        {
            this.modelIndex = -1;
            this.workingPeriodDaysView = [];
            this.labels=[];
            this.period = new Period()
            if (modelIndex !== undefined)
                this.modelIndex = modelIndex;

            if (workingPeriod !== undefined && workingPeriod)
            {
                this.period.start.setTimeByHm(workingPeriod.period.start.hour, workingPeriod.period.start.minute);
                this.period.end.setTimeByHm(workingPeriod.period.end.hour, workingPeriod.period.end.minute);

                for (var k = 0; k < workingPeriod.workingPeriodDays.length; k++)
                    this.workingPeriodDaysView.push(new WorkingPeriodDayView(workingPeriod.workingPeriodDays[k],k));
            }
            else
            {
                for (var i=0;i<7;i++)  //Seven days
                    this.workingPeriodDaysView.push(new WorkingPeriodDayView());
                //Default values

                this.period.start.setTimeByHm(10, 0);
                this.period.end.setTimeByHm(19, 0);
            }
            this.update();
        };

        WorkingPeriodView.prototype.getModel = function()
        {
            if (this.modelIndex!=-1)
                return SiteData.defaultSite.workingPeriods[this.modelIndex];
            return null;
        };

        WorkingPeriodView.prototype.updateModel = function(workingPeriodDayViewsToClose)
        {
            let  workingPeriod = this.getModel();
            if (!workingPeriod) {
                workingPeriod = new WorkingPeriod(null,SiteData.defaultSite);
                this.modelIndex = SiteData.defaultSite.addWorkingPeriod(workingPeriod);
            }

            workingPeriod.period = new Period(this.period);

            let workingPeriodDay;
            for (let k = 0; k < this.workingPeriodDaysView.length; k++) {
                if (this.workingPeriodDaysView[k].modelIndex==null) {
                    workingPeriodDay = new WorkingPeriodDay();
                    this.workingPeriodDaysView[k].modelIndex = workingPeriod.addWorkingPeriodDay(workingPeriodDay);
                } else {
                    workingPeriodDay = workingPeriod.workingPeriodDays[this.workingPeriodDaysView[k].modelIndex];
                }
                const needToCleanWorkingPeriodDayResources = workingPeriodDayViewsToClose && workingPeriodDayViewsToClose.indexOf(this.workingPeriodDaysView[k]) != -1;
                this.workingPeriodDaysView[k].updateModel(workingPeriodDay, needToCleanWorkingPeriodDayResources);
            }
        };

        WorkingPeriodView.prototype.nbOpenDays = function() {
            var openDays =0;
            for (var k = 0; k < this.workingPeriodDaysView.length; k++)
                if (this.workingPeriodDaysView[k].openDay)
                    openDays++;
            return openDays;
        };

        WorkingPeriodView.prototype.intersect = function(workingPeriodView)
        {
            var intersect = false;
            if (this.period.intersect(workingPeriodView.period))
            {
                for (var k = 0; k < this.workingPeriodDaysView.length && !intersect; k++)
                {
                    if (this.workingPeriodDaysView[k].openDay && workingPeriodView.workingPeriodDaysView[k].openDay)
                        intersect = true;
                }

            }
            return intersect;
        };

        WorkingPeriodView.prototype.update = function()
        {
            this.updateTimesStr();
            this.updateLabels();
        };

        WorkingPeriodView.prototype.updateTimesStr = function()
        {
            this.period.start.label = moment().hour(this.period.start.hour).minute(this.period.start.minute).format("LT");
            this.period.end.label = moment().hour(this.period.end.hour).minute(this.period.end.minute).format("LT");
        };

        WorkingPeriodView.prototype.updateLabels = function() {
            this.labels = [];
            let daysLabel = DateSrv.daysOfWeekLabel;
            let startPeriod = -1;
            let isFirstWord = true;

            for (let i = 0; i < this.workingPeriodDaysView.length; i++) {
                if (this.workingPeriodDaysView[i].openDay) {
                    if (startPeriod == -1)
                        startPeriod = i;
                } else {
                    if (startPeriod != -1)//end of period
                    {
                        if (startPeriod + 1 < i)//More than one day
                        {
                            this.addDaysOnLabels(isFirstWord, startPeriod, i, daysLabel);
                            isFirstWord = false;
                        } else {
                            if (isFirstWord) {
                                this.labels.push(this.uppercaseFirstLetter(daysLabel[startPeriod]));
                                isFirstWord = false;
                            } else {
                                this.labels.push(daysLabel[startPeriod]);
                            }
                        }
                        startPeriod = -1;
                    }
                }
            }
            if (startPeriod != -1)//end of period
            {
                this.addDaysOnLabels(isFirstWord, startPeriod, this.workingPeriodDaysView.length, daysLabel);
            }

            if (this.labels.length == 0) {
                let noDay = gettextCatalog.getString("Aucun jour");

                this.labels.push(noDay);
            }
        };

        WorkingPeriodView.prototype.addDaysOnLabels = function(isFirstWord, startPeriodIndex, endPeriodIndex, daysLabel) {
            let firstWord = gettextCatalog.getString("Du");
            let word = gettextCatalog.getString("du");
            let at = gettextCatalog.getString("au");
            let nextPeriodIndex = startPeriodIndex + 1;
            if (nextPeriodIndex === endPeriodIndex) {
                if (isFirstWord) {
                    this.labels.push(this.uppercaseFirstLetter(daysLabel[startPeriodIndex]));
                } else {
                    this.labels.push(daysLabel[startPeriodIndex]);
                }
            } else if (nextPeriodIndex !== endPeriodIndex - 1) {
                if (this.labels.length === 0) {
                    word = firstWord;
                }
                this.labels.push(word + " " + daysLabel[startPeriodIndex] + " " + at + " " + daysLabel[endPeriodIndex - 1]);
            } else if (isFirstWord) {
                this.labels.push(this.uppercaseFirstLetter(daysLabel[startPeriodIndex]), daysLabel[endPeriodIndex - 1]);
            } else {
                this.labels.push(daysLabel[startPeriodIndex], daysLabel[endPeriodIndex - 1]);
            }
        };

        WorkingPeriodView.prototype.uppercaseFirstLetter = function (word) {
          return word.replace(/(?:^|\s)\S/g,
              function(firstLetter) {
                return firstLetter.toUpperCase();
              });
        };

        return  WorkingPeriodView;
    }]);



angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDayView', ["WorkingPeriodDayHrView",function (WorkingPeriodDayHrView){

        var  WorkingPeriodDayView = function(workingPeriodDay,modelIndex) {
            this.openDay = false;
            this.modelIndex = null;
            if (modelIndex!==undefined)
                this.modelIndex = modelIndex;
            if (workingPeriodDay !== undefined && workingPeriodDay) {
                this.openDay = workingPeriodDay.openDay;
            }
        };

        WorkingPeriodDayView.prototype.updateModel = function(workingPeriodDay, needToCleanWorkingPeriodDayResources) {
            workingPeriodDay.openDay = this.openDay;
            if(needToCleanWorkingPeriodDayResources) {
                workingPeriodDay.workingPeriodDayHrs = [];
                workingPeriodDay.workingPeriodDayPrs = [];
            }
        };

        return  WorkingPeriodDayView;
    }]);

angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDayHrView', ["gettextCatalog",function (gettextCatalog){

        var  WorkingPeriodDayHrView = function(specificResource,modelIndex)
        {
            if (specificResource !== undefined && specificResource)
            {
                this.modelIndex = modelIndex;
                this.start = {hour : specificResource.start.hour, minute : specificResource.start.minute};
                this.end = {hour : specificResource.end.hour, minute : specificResource.end.minute};
                this.enable= specificResource.enable;
                this.update();
            }
        };

        WorkingPeriodDayHrView.prototype.update = function() {
            this.updateTimesStr();
        };

        WorkingPeriodDayHrView.prototype.updateTimesStr = function()
        {
            var hourSeparator = gettextCatalog.getString("h");
            this.start.label = this.start.hour + hourSeparator +  (this.start.minute<10 ? "0" : "") + this.start.minute;
            this.end.label = this.end.hour + hourSeparator +  (this.end.minute<10 ? "0" : "") + this.end.minute;
        };

        return  WorkingPeriodDayHrView;
    }]);


// WEBPACK FOOTER //
// ./js/services/views/WorkingPeriodView.js